/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEmployeeTokensInCalculation} from '../api'

 export const useQueryGetEmployeeTokensInCalculation = createReactQueryHook('getEmployeeTokensInCalculation', getEmployeeTokensInCalculation)
